import { ContentDataTypes } from '@news-mono/web-common'
import { SectionHeaderProps } from '../section-header/SectionHeader/SectionHeader'
import { ThemeMargins } from '../__styling/settings/metrics'

export interface SectionHeaderNavLink {
    text: string
    link: string
    isExternalLink?: boolean
}
export interface CollectionRouteProps {
    sectionHeader?: SectionHeaderProps
    verticalSpacing?: keyof ThemeMargins | undefined
}

export const calculateExpectedCardCountFromContentData = (
    data: ContentDataTypes,
): number => {
    if (data === undefined) {
        throw new Error(
            'calculateExpectedCardCountFromContentData received no data',
        )
    }
    if (data.type === 'active-promotion') {
        return 1
    }
    if (data.type === 'video-listing') {
        return data.paging.pageSize
    }
    if (data.type === 'aggregated') {
        return data.sources.reduce((acc, val) => {
            if (val.type === 'listing') {
                acc += val.paging.pageSize
            } else if (val.type === 'curation') {
                acc += val.pageSize
            }
            return acc
        }, 0)
    } else if (data.type !== 'listing') {
        return data.pageSize
    }
    return data.paging.pageSize
}
